// src/views/CookiePolicyPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Helmet>
        <title>Cookie Policy | Spatchy</title>
        <meta name="description" content="Spatchy Cookie Policy — how we use cookies and similar tracking technologies." />
      </Helmet>

      {/* Header */}
      <div className="border-b border-white/10 bg-slate-900/80 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <h1 className="text-3xl font-bold text-white">Cookie Policy</h1>
          <p className="text-slate-400 mt-2 text-sm">
            How Spatchy uses cookies and similar tracking technologies.
          </p>
        </div>
      </div>

      {/* Termly Embed */}
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="bg-white rounded-xl overflow-hidden shadow-2xl">
          <iframe
            src="https://app.termly.io/policy-viewer/policy.html?policyUUID=ef9a86b2-f339-4048-b918-a257e5c9e018"
            title="Spatchy Cookie Policy"
            className="w-full"
            style={{ height: '80vh', minHeight: '600px', border: 'none' }}
          />
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;